import CardTitleWithIcon from "@/components/company/card-title-with-icon";
import ToggleableBadgeList from "@/components/company/shared/toggleable-badge-list";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { useTranslation } from "@/hooks/useTranslation";
import { CompanyDTO } from "@shaarp/common";
import { CpuIcon } from "lucide-react";

const TECH_INITIAL_DISPLAY = 18;

function LabelledBadgeList({
  label,
  items,
}: {
  readonly label: string;
  readonly items: readonly string[];
}) {
  return (
    <>
      <span className="text-sm text-muted-foreground">{label}</span>
      <ToggleableBadgeList
        items={items}
        initialDisplay={TECH_INITIAL_DISPLAY}
        getKey={(item) => item}
      />
    </>
  );
}

type CardCompanyTechnologiesProps = {
  readonly company: CompanyDTO;
};

export default function CardCompanyTechnologies({
  company,
}: CardCompanyTechnologiesProps) {
  const { t } = useTranslation();

  const technologies = company.technologies ?? [];
  const adPixels = company.adPixels ?? [];
  if (technologies.length === 0 && adPixels.length === 0) return null;

  return (
    <Card className="flex flex-col min-w-0 overflow-hidden">
      <CardHeader>
        <CardTitleWithIcon
          icon={CpuIcon}
          title={t("company.insights.digital.technologiesTitle")}
        />
      </CardHeader>
      <CardContent className="flex flex-col gap-3">
        {technologies.length > 0 && (
          <LabelledBadgeList
            label={t("company.insights.digital.techCountLabel", {
              count: technologies.length,
            })}
            items={technologies}
          />
        )}
        {adPixels.length > 0 && (
          <LabelledBadgeList
            label={t("company.insights.digital.adPixelsTitle")}
            items={adPixels}
          />
        )}
      </CardContent>
    </Card>
  );
}
